import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getUsers = (role) => api.get("/users", { params: { role } }).then((r) => r.data);
export const getUser = (id) => api.get(`/users/${id}`).then((r) => r.data);
export const getCategories = () => api.get("/categories").then((r) => r.data.categories);
export const searchWorkers = (params) => api.get("/workers", { params }).then((r) => r.data);
export const getResume = (id) => api.get(`/resume/${id}`).then((r) => r.data);
export const listAssessments = (workerId) =>
  api.get("/assessments", { params: { worker_id: workerId } }).then((r) => r.data);

export const startAssessment = (worker_id, category) =>
  api.post("/assessments/start", { worker_id, category }).then((r) => r.data);
export const replyAssessment = (sessionId, message) =>
  api.post(`/assessments/${sessionId}/reply`, { message }).then((r) => r.data);
export const finishAssessment = (sessionId) =>
  api.post(`/assessments/${sessionId}/finish`).then((r) => r.data);

export const transcribeAudio = (blob) => {
  const fd = new FormData();
  fd.append("file", blob, "answer.webm");
  return api.post("/transcribe", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const ttsSpeak = async (text) => {
  const res = await api.post("/tts", { text }, { responseType: "blob" });
  return URL.createObjectURL(res.data);
};

export const endorseSkill = (skillId, employer_id) =>
  api.post(`/skills/${skillId}/endorse`, { employer_id }).then((r) => r.data);
export const getShortlist = (employer_id) =>
  api.get("/shortlist", { params: { employer_id } }).then((r) => r.data);
export const addShortlist = (employer_id, worker_id, note) =>
  api.post("/shortlist", { employer_id, worker_id, note }).then((r) => r.data);
export const updateShortlistNote = (employer_id, worker_id, note) =>
  api.patch("/shortlist", { employer_id, worker_id, note }).then((r) => r.data);
export const removeShortlist = (employer_id, worker_id) =>
  api.delete("/shortlist", { params: { employer_id, worker_id } }).then((r) => r.data);

export const createEndorsementRequest = (worker_id, employer_id, skill_id) =>
  api.post("/endorsement-requests", { worker_id, employer_id, skill_id }).then((r) => r.data);
export const listEndorsementRequests = (params) =>
  api.get("/endorsement-requests", { params }).then((r) => r.data);
export const fulfillEndorsementRequest = (id) =>
  api.post(`/endorsement-requests/${id}/fulfill`).then((r) => r.data);
export const declineEndorsementRequest = (id) =>
  api.post(`/endorsement-requests/${id}/decline`).then((r) => r.data);

// Auth
export const authRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const authLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authGoogleSession = (session_id, role) =>
  api.post("/auth/google/session", { session_id, role }).then((r) => r.data);
export const updateProfile = (payload) => api.patch("/auth/me", payload).then((r) => r.data);

// Connections
export const listConnections = () => api.get("/connections").then((r) => r.data);
export const requestConnection = (to_user_id, message) =>
  api.post("/connections", { to_user_id, message }).then((r) => r.data);
export const resolveConnection = (id, action) =>
  api.patch(`/connections/${id}`, {}, { params: { action } }).then((r) => r.data);
export const removeConnection = (id) => api.delete(`/connections/${id}`).then((r) => r.data);

// Messages
export const listThreads = () => api.get("/threads").then((r) => r.data);
export const getMessages = (otherId) => api.get(`/messages/${otherId}`).then((r) => r.data);
export const sendMessage = (to_user_id, text) => api.post("/messages", { to_user_id, text }).then((r) => r.data);
export const getUnreadCount = () => api.get("/unread-count").then((r) => r.data);

// Recommendations
export const requestRecommendation = (to_user_id, context) =>
  api.post("/recommendations/request", { to_user_id, context }).then((r) => r.data);
export const listRecommendations = (role = "reviewer") =>
  api.get("/recommendations", { params: { role } }).then((r) => r.data);
export const writeRecommendation = (id, text, relationship) =>
  api.post(`/recommendations/${id}/write`, { text, relationship }).then((r) => r.data);
export const declineRecommendation = (id) =>
  api.post(`/recommendations/${id}/decline`).then((r) => r.data);

export const pendingConnectionCount = () =>
  api.get("/connections/pending-count").then((r) => r.data);
export const verifyBadge = (hash) => api.get(`/verify/${hash}`).then((r) => r.data);

// Communities
export const listCommunities = () => api.get("/communities").then((r) => r.data);
export const getCommunity = (slug) => api.get(`/communities/${slug}`).then((r) => r.data);
export const joinCommunity = (slug, payload) => api.post(`/communities/${slug}/join`, payload).then((r) => r.data);
export const updateCommunityVisibility = (slug, show_on_resume) =>
  api.patch(`/communities/${slug}/membership`, { show_on_resume }).then((r) => r.data);
export const leaveCommunity = (slug) => api.delete(`/communities/${slug}/membership`).then((r) => r.data);
export const myCommunities = () => api.get("/my/communities").then((r) => r.data);
